import { useCallback, useEffect, useState } from "react";
import { getDashboardSaleSummary } from "../../services";
import { DashboardSaleSummary } from "../../types/dashboard.type";
import { Dayjs } from "dayjs";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SalePieChart from "./SalePieChart";
import SaleSummarySkeleton from "./Skeleton/SaleSummarySkeleton";

interface SaleSummaryProps {
  selectedDate: Dayjs | null;
}

export default function SaleSummary({ selectedDate }: SaleSummaryProps) {
  const [saleSummary, setSaleSummary] = useState<DashboardSaleSummary>();

  const onGetSaleSummary = useCallback(async (date: Dayjs) => {
    const {
      data: { data },
    } = await getDashboardSaleSummary(date.format("YYYY-MM-DD"));

    setSaleSummary(data);
  }, []);

  useEffect(() => {
    if (selectedDate) {
      onGetSaleSummary(selectedDate);
    }
  }, [selectedDate, onGetSaleSummary]);

  if (!saleSummary) return <SaleSummarySkeleton />;

  return (
    <Paper sx={{ height: "100%" }}>
      <Typography variant="body1" fontWeight={600}>
        ประเภทการจ่าย
      </Typography>
      <Box sx={{ minHeight: 250, display: "flex", alignItems: "center" }}>
        <SalePieChart
          invoiceTotalAmount={saleSummary.invoice_total_amount}
          cashsaleTotalAmount={saleSummary.cashsale_total_amount}
        />
      </Box>
    </Paper>
  );
}
